<template>
	<div :class="{ flex: true, center }" :style="{ justifyContent: justify, alignItems: align }">
		<slot/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'Flex',

	props: {
		center: { type: Boolean, default: false },
		justify: { type: String, default: 'flex-start' },
		align: { type: String, default: 'flex-start' } 
	}
})
</script>

<style lang="scss">
.flex { 
	display: flex;
	height: 100%;
	width: 100%;

	&.center {
		justify-content: center !important;
		align-items: center !important;
	}

	> div {
		flex: 1 0 auto;
	}
}
</style>